/**
 * Format a booking slot as a single expected arrival time (start only).
 * Accepts legacy "11:30 AM - 12:00 PM" ranges and returns the start segment.
 */
export function formatArrivalTime(slotOrTime) {
  if (!slotOrTime) return "";

  if (typeof slotOrTime === "string") {
    return slotOrTime.split(" - ")[0].trim();
  }

  const raw =
    slotOrTime.timeRange ||
    slotOrTime.timeKey ||
    slotOrTime.selectedTime ||
    "";

  if (!raw) return "";
  return String(raw).split(" - ")[0].trim();
}

export default formatArrivalTime;
